import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '@common/models';

export interface IPGRColorModel extends IModel {
  pgrColorId: number;
  type: string;
  code: string;
  sort: string;
  defaultPetpassPetColorId?: number | undefined;
}

export class PGRColorModel
  extends Model
  implements ModelRecord<IPGRColorModel>
{
  pgrColorId: number;
  type: string;
  code: string;
  sort: string;
  defaultPetpassPetColorId: number | undefined;

  constructor(params?: Partial<IPGRColorModel>) {
    super(params);
    this.pgrColorId = defaultTo(params?.pgrColorId, 0);
    this.type = defaultTo(params?.type, '');
    this.code = defaultTo(params?.code, '');
    this.sort = defaultTo(params?.sort, '');
    this.defaultPetpassPetColorId = defaultTo(
      params?.defaultPetpassPetColorId,
      undefined,
    );
  }
}
